import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountCreationComponent } from './pages/account-creation/account-creation.component';
import { RiskResultPageComponent } from './pages/risk-result-page/risk-result-page.component';
import { FatcaPepPageComponent } from './pages/fatca-pep-page/fatca-pep-page.component';
import { ConfirmationPageComponent } from './pages/confirmation-page/confirmation-page.component';

const routes: Routes = [
  {
    path: '',
    component :AccountCreationComponent
  },
  {
    path:'fatca-pep',
    component : FatcaPepPageComponent
  },
  {
    path: 'risk',
    component: RiskResultPageComponent
  },
  {
    path: 'confirmation',
    component: ConfirmationPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerInformationRoutingModule { }